import { Stack, Typography } from '@mui/material'
import { DataGrid } from 'Components/LifeDataGrid'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { convertToUserDateFormate, formatTextWithLineBreaks } from 'utils/helpers'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function OperationTable({ fetchOperations, operations }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)
  const siteDevise = useSelector((store) => store.devise)

  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }

  const columns = [
    {
      field: 'Date',
      headerName: t('dashboardDetail.colDate'),
      width: 100,
      editable: true,
      type: 'date',
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.Date),
    },
    {
      field: 'Compte',
      headerName: t('dashboardDetail.colAccount'),
      // type: 'number',
      width: 250,
      valueGetter: (params) => `${params.row.NCompte ? params.row.NCompte.ncNom : ''}`,
    },
    {
      field: 'Libelle',
      headerName: t('dashboardDetail.colLabel'),
      width: 300,
      editable: true,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4' }}>
          {formatTextWithLineBreaks(params.row.Libelle)}
        </div>
      ),
    },
    {
      field: 'Categorie',
      headerName: t('dashboardDetail.colCategory'),
      width: 150,
      valueGetter: (params) =>
        `${params.row.SousCategorie.length > 0 ? params.row.SousCategorie[0].Categorie : ''}`,
    },
    {
      field: 'SousCategorie',
      headerName: t('dashboardDetail.colSubcategory'),
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 150,
      valueGetter: (params) =>
        `${params.row.SousCategorie.length ? params.row.SousCategorie[0].SousCategorie : ''}`,
    },
    {
      field: 'original_montant',
      headerName: t('dashboardDetail.colOriginalAmount'),
      width: 120,
      type: 'number',
      valueGetter: (params) => params.row.original_montant || params.row.Montant,
    },
    {
      field: 'original_devise',
      headerName: t('dashboardDetail.colOriginalCurrency'),
      width: 100,
      valueGetter: (params) => params.row.original_devise || params.row.NCompte?.Devise || 'EUR',
    },
    {
      field: 'Montant',
      headerName: t('dashboardDetail.colConvertedAmount'),
      width: 120,
      editable: true,
      type: 'number',
      // Backend now returns converted amounts based on currency parameter
    },
    {
      field: 'Devise',
      headerName: t('dashboardDetail.colConvertedCurrency'),
      // type: 'number',
      width: 100,
      valueGetter: (params) => `${siteDevise.devise.Code_iso || 'EUR'}`,
    },
  ]

  return (
    <div
      style={{
        height: 750,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      {/* <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        Mes Opérations ({operations.count})
      </Typography> */}

      <DataGrid
        rows={operations.results ? operations.results : []}
        columns={columns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        // onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        // components={{
        //   NoRowsOverlay: () => (
        //     <Stack height="100%" alignItems="center" justifyContent="center">
        //       Aucune donnée trouvée
        //     </Stack>
        //   ),
        //   NoResultsOverlay: () => (
        //     <Stack height="100%" alignItems="center" justifyContent="center">
        //       Aucune donnée trouvée
        //     </Stack>
        //   ),
        // }}
        // checkboxSelection
      />
    </div>
  )
}
export default OperationTable

// import * as React from 'react'
// import Table from '@mui/material/Table'
// import TableBody from '@mui/material/TableBody'
// import TableCell from '@mui/material/TableCell'
// import TableContainer from '@mui/material/TableContainer'
// import TableHead from '@mui/material/TableHead'
// import TableRow from '@mui/material/TableRow'
// import Paper from '@mui/material/Paper'
// import { Box, Button, CircularProgress } from '@mui/material'
// // import { useLocation } from 'react-router-dom'

// export default function OperationTable({ data, loading, setOperations }) {
//   const [rowsPerPage, setRowsPerPage] = React.useState(20)
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(rowsPerPage + 20)
//     setOperations(rowsPerPage + 20, true)
//   }

//   return (
//     <TableContainer component={Paper}>
//       <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
//         <TableHead>
//           <TableRow>
//             <TableCell>Date</TableCell>
//             <TableCell>Compte</TableCell>
//             <TableCell>Libelle</TableCell>

//             <TableCell>Catégorie</TableCell>
//             <TableCell>Sous-Catégorie</TableCell>

//             <TableCell>Montant</TableCell>
//             <TableCell>Devise</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {loading ? (
//             <TableRow>
//               <TableCell colSpan={5}>
//                 <CircularProgress />
//               </TableCell>
//             </TableRow>
//           ) : (
//             data &&
//             data.results &&
//             data.results.map((row) => (
//               <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                 <TableCell component="th" scope="row">
//                   {row.Date}
//                 </TableCell>
//                 <TableCell>{row.Libelle}</TableCell>
//                 <TableCell>{row?.NCompte?.ncNom}</TableCell>
//                 {/* <TableCell>{row.compte}</TableCell> */}
//                 <TableCell>
//                   {row.SousCategorie.length > 0 && row.SousCategorie[0].Categorie}
//                 </TableCell>
//                 <TableCell>
//                   {row.SousCategorie.length > 0 && row.SousCategorie[0].SousCategorie}
//                 </TableCell>
//                 <TableCell>{row.Montant}</TableCell>
//                 <TableCell>{row?.NCompte?.Devise}</TableCell>
//               </TableRow>
//             ))
//           )}
//         </TableBody>
//       </Table>
//       {data.count > 20 && data.results.length % 20 === 0 ? (
//         <Box display={'flex'} justifyContent={'center'}>
//           <Button onClick={handleChangeRowsPerPage}>Load More</Button>
//         </Box>
//       ) : (
//         data.count > 20 && (
//           <Box display={'flex'} justifyContent={'center'}>
//             <Button
//               onClick={() => {
//                 setRowsPerPage(20)
//                 setOperations(20, true)
//               }}
//             >
//               Return to initial Size
//             </Button>
//           </Box>
//         )
//       )}
//       <h5 className="text-center">{data.count === 0 && 'No Data'}</h5>
//     </TableContainer>
//   )
// }
